"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Badge;

var _react = _interopRequireDefault(require("react"));

var _useComponentStyling2 = _interopRequireDefault(require("../../hooks/useComponentStyling"));

var _text = _interopRequireDefault(require("../text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BASE_CLASS = "lth-c-badge";
var DEFAULT_LABEL = 12;

function Badge(props) {
  var label = props.label.toString();

  var _useComponentStyling = (0, _useComponentStyling2.default)(BASE_CLASS, _objectSpread({
    variant: 'common'
  }, props), ["variant"]),
      classNames = _useComponentStyling.classNames;

  var style = {};
  props.backgroundColor && (style.backgroundColor = props.backgroundColor);
  var textSize = {
    small: 'xsmall',
    regular: 'small'
  }[props.size];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames,
    style: style
  }, /*#__PURE__*/_react.default.createElement(_text.default, {
    size: textSize,
    color: props.textColor
  }, label.length ? label : DEFAULT_LABEL));
}

Badge.METADATA = {
  name: "Badge",
  description: "A Badge",
  props: [{
    name: "label",
    type: "string",
    default: "",
    description: "The label to be shown inside the badge"
  }, {
    name: "variant",
    type: "string",
    default: "common",
    description: "Choose which variant of button to display",
    options: [{
      value: "primary",
      description: "For the principal call to action on the page."
    }, {
      value: "common",
      description: "For secondary actions on each page."
    }, {
      value: "danger",
      description: ""
    }, {
      value: "warning",
      description: ""
    }]
  }, {
    name: "size",
    type: "string",
    default: "regular",
    options: [{
      value: "small"
    }, {
      value: "regular"
    }]
  }, {
    name: "textColor",
    type: "string"
  }, {
    name: "backgroundColor",
    type: "string"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }]
};